import React from "react";
import classNames from "classnames";

import Placeholder, { Rect } from "components/Placeholder";

const ButtonPlaceholder: React.FC<{
  className?: string;
  height?: string;
  width?: string;
}> = ({ className, height = "30", width = "100%" }) => (
  <Placeholder
    className={classNames(className, "rounded-full")}
    width={width}
    height={height}
  >
    <Rect y="0" width="100%" height="100%" />
  </Placeholder>
);

export default ButtonPlaceholder;
